export default function jsonld(tag: string, data: object) {
  return {
    "@context": "http://schema.org",
    "@type": tag,
    ...data,
  };
}
